import { Link } from "react-router-dom";
import { resolveMedia } from "../lib/api";
import { Plus } from "lucide-react";

export default function StoriesBar({ stories = [], isAdmin = false }) {
  if (!stories.length && !isAdmin) return null;

  return (
    <div data-testid="stories-bar" className="px-4 sm:px-8 lg:px-12 py-6">
      <div className="flex items-center gap-4 overflow-x-auto scrollbar-hide pb-2">
        {isAdmin && (
          <Link
            to="/admin?tab=upload&type=story"
            data-testid="story-add-btn"
            className="flex flex-col items-center gap-2 flex-shrink-0"
          >
            <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-full border-2 border-dashed border-[#FF6B00]/60 flex items-center justify-center text-[#FF6B00] hover:border-[#FF6B00] hover:bg-[#FF6B00]/10 transition-colors">
              <Plus className="w-6 h-6" />
            </div>
            <span className="text-[10px] uppercase tracking-wider text-zinc-400">Add</span>
          </Link>
        )}
        {stories.map((s) => (
          <Link
            key={s.id}
            to={`/story/${s.id}`}
            data-testid={`story-${s.id}`}
            className="flex flex-col items-center gap-2 flex-shrink-0 group"
          >
            <div className="story-ring">
              <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-full overflow-hidden border-2 border-black bg-zinc-900">
                {resolveMedia(s.thumbnail) ? (
                  <img src={resolveMedia(s.thumbnail)} alt={s.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform" />
                ) : (
                  <div className="w-full h-full bg-gradient-to-br from-[#FF6B00] to-[#FFB800]" />
                )}
              </div>
            </div>
            <span className="text-[10px] uppercase tracking-wider text-zinc-400 max-w-[80px] truncate">{s.title}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
